
import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { JobCardProps } from './helper';
import Consolas from '../../../fonts/Consolas';
import { H2, H4, PARAGRAPH } from '../../../helper/constants';
import StarIcon from '@mui/icons-material/Star';
import RenderIf from '../../RenderIf';
import { SuccessColor, WarningColor } from '../../../helper/constants/colors';
import Tags from '../../Tags';
import { getTimeFrameString } from '../../../helper/functions';
// import { blankClick } from '../../../helper/functions';
const JobCard = ({ title, company, start="", end = "Present", description = [], tools=[] }: JobCardProps): JSX.Element =>
(
    <Accordion>
        <AccordionSummary
            expandIcon=
            {
                <RenderIf condition={end === "Present"} fallback={<ExpandMoreIcon />}>
                    <Tooltip title="Current Position">                    
                        <StarIcon htmlColor={WarningColor.main}/>
                    </Tooltip>
                </RenderIf>
            }
            aria-controls="panel1a-content"
            id="panel1a-header">

            <Consolas as={H2}>{company}: <i>{title}</i>  </Consolas>

        </AccordionSummary>
        <AccordionDetails>
            <Consolas as={H4}>{start} - {end} <span style={{color:SuccessColor.dark, fontSize: 16}}>{getTimeFrameString(start, end)} </span></Consolas>
            <ul>
                {
                    description.map((e, i) =>
                        <li key={i}><Consolas as={PARAGRAPH}>{e}</Consolas></li>)
                }
            </ul>
            <Tags collection={tools}/>
        </AccordionDetails>
    </Accordion>
)

export default JobCard;
